import { useQuery } from "@tanstack/react-query";
import { Target } from "lucide-react";
import { matchesApi } from "@/api/matches";
import { useScope } from "@/app/useScope";
import { MatchDayBoard } from "@/components/MatchDayBoard";
import { RequireContext, EmptyState, ErrorState, CardListSkeleton } from "@/components/StateViews";
import { isGroupStage } from "@/lib/stage";

export function TippingPage() {
  return (
    <RequireContext>
      <GroupTipping />
    </RequireContext>
  );
}

function GroupTipping() {
  const scope = useScope();
  const q = useQuery({
    queryKey: ["matches", scope.leagueId, scope.tournamentId],
    queryFn: () => matchesApi.list(scope),
  });

  const groupMatches = (q.data ?? []).filter((m) => isGroupStage(m.stage));

  return (
    <div className="space-y-4">
      <div>
        <h1 className="flex items-center gap-2 text-xl font-semibold tracking-tight">
          <Target className="size-5 text-primary" /> Csoportkör
        </h1>
        <p className="text-sm text-muted-foreground">Írd be a tipped — automatikusan mentődik. Egy meccset megjelölhetsz ⭐ Tuti tippnek, a csapat nevére kattintva a statisztikái is előjönnek.</p>
      </div>

      {q.isLoading ? (
        <CardListSkeleton />
      ) : q.error ? (
        <ErrorState error={q.error} />
      ) : groupMatches.length === 0 ? (
        <EmptyState title="Nincs csoportkörös mérkőzés" description="Ehhez a bajnoksághoz még nincs csoportkörös meccs." icon={<Target className="size-7" />} />
      ) : (
        <MatchDayBoard matches={groupMatches} />
      )}
    </div>
  );
}
